export default __webpack_public_path__ + "static/media/card-terbimbing.60178709.webp";